import React from "react";
import "../../styles/insightCards.css";

/**
 * Card wrapper with optional title. Uses KeyInsights styling.
 */
export default function InsightCard({ title, children }) {
  return (
    <div className="insight-card">
      {title && (
        <div className="insight-title-row">
          <h3 className="insight-title">{title}</h3>
        </div>
      )}
      {children}
    </div>
  );
}
